import { memo } from 'react';

import { FieldItem } from './field-item';
import { StaticFieldsContainerProps } from './types';

export const StaticFieldsContainer = memo(
  ({
    name,
    fields,
    onRemove,
    simplified,
    onCopyField,
    allowInputId,
    allowOutcomes,
    allowPageBreak,
    allowFieldArray,
    onPasteFieldAfter,
    allowOutcomeFields,
    allowReferenceCodes,
    outcomeFieldSources,
  }: StaticFieldsContainerProps) => {
    const canDeleteFields = fields.length > 1;

    return (
      <div
        data-testid={`field-container-${name}`}
        className="flex flex-col gap-4 rounded-lg border border-dashed border-gray-200 p-3 dark:border-gray-700"
      >
        {fields.map((value, index) => (
          <FieldItem
            value={value}
            index={index}
            key={value.id}
            isDragging={false}
            onRemove={onRemove}
            containerPath={name}
            sortableId={undefined}
            simplified={simplified}
            name={`${name}.${index}`}
            allowInputId={allowInputId}
            canDelete={canDeleteFields}
            allowOutcomes={allowOutcomes}
            allowPageBreak={allowPageBreak}
            allowFieldArray={allowFieldArray}
            allowOutcomeFields={allowOutcomeFields}
            allowReferenceCodes={allowReferenceCodes}
            outcomeFieldSources={outcomeFieldSources}
            onCopy={onCopyField ? () => onCopyField(value) : undefined}
            onPasteAfter={
              onPasteFieldAfter ? () => onPasteFieldAfter(index) : undefined
            }
          />
        ))}
      </div>
    );
  }
);

StaticFieldsContainer.displayName = 'StaticFieldsContainer';
